module.exports = {"id":"186405","name":"Franco Di Santo","rating":"76","photo":"./data/images/photos/4/186405.png","club":{"name":"FC Schalke 04","logo":"./data/images/clubs/FCSchalke04.png"},"positions":["BU","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FrancoDiSanto0.json
// module id = 1481
// module chunks = 0